import React, { useEffect, useRef, useState } from "react"
import "./ProrgamList.scss"
import programApi from "Api/programApi"
import {
  Button,
  Col,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { useNavigate } from "react-router-dom"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { toast } from "react-toastify"
import { ToastContainer } from 'react-toastify'

const ProgramList = () => {
  document.title = "Program"
  const uploadbtn = useRef()
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const [programDetails, setProgramDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [loading, setLoading] = useState(true)
  const [addProgramLoader, setAddProgramLoader] = useState(false)
  const [filterStatus, setFilterStatus] = useState("all");
  const [filteredProgramDetails, setFilteredProgramDetails] = useState([]);
  
  const getAllProgramDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    programApi
      .getProgram(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setProgramDetails(response.data.program)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
        console.log("Error Fetching Program", error)
      })
  }
  useEffect(() => {
    getAllProgramDetails()
  }, [accessToken, page, limit])

  useEffect(() => {
    if (filterStatus === "all") {
      setFilteredProgramDetails(programDetails);
    } else {
      const filteredData = programDetails.filter(
        program => program.verifiedStatus === filterStatus
      );
      setFilteredProgramDetails(filteredData);
    }
  }, [filterStatus, programDetails]);
  

  const totalPages = Math.ceil(totalRecords / limit)

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Program", link: "#" },
    { label: "Program List", link: "#" },
  ]

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }

  const [excelLoader, setExcelLoader] = useState(false)

  const handleFileChange = event => {
    setExcelLoader(true)

    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    programApi
      .uploadProgramByExcel(formData, config)
      .then(res => {
        getAllProgramDetails()
        console.log(res.data)
        event.target.value = ""
        setExcelLoader(false)
        toast.success(res.data.message)
      })
      .catch(err => {
        console.log(err)
        event.target.value = ""
        setExcelLoader(false)
        toast.error(err.response.data.message)  
      })
  }
  const handleAddProgramClick = () => {
    setAddProgramLoader(true)
    setTimeout(() => {
      setAddProgramLoader(false)
      navigate("/addProgram")
    }, 500)
  }

  return (
    <>
      <ToastContainer/>
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Program" />

            <div className="d-flex align-items-center gap-3">
            <Input
                type="select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{ width: "150px" }}
              >
                <option value="all">All</option>
                <option value="approve">Approved</option>
                <option value="reject">Rejected</option>
                <option value="pending">Pending</option>
              </Input>


              <input
                type="file"
                ref={uploadbtn}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <Button
                type="button"
                color="success"
                className="waves-effect"
                onClick={handleUploadButtonClick}
              >
                {excelLoader ? (
                  <Spinner size="sm" />
                ) : (
                  <i className="mdi mdi-microsoft-excel" />
                )}
              </Button>

              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleAddProgramClick}
              >
                Add Program
                {/* {addProgramLoader ? (
                  <Spinner size="sm"/>
                ):(
                  "Add Program"
                  )} */}
              </Button>
            </div>
          </div>

          <div className="prorgam-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Program Name</th>
                    <th>Duration</th>
                    <th>TuitionFee</th>
                    <th>Eligibility Criteria</th>
                    <th>Total Seats</th>
                    <th>Verified Status</th>
                    <th>Edit</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProgramDetails.map((program, index) => (
                    <tr key={program._id} className="university-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{program.programName}</td>
                      <td>{program.duration}</td>
                      <td>{program.tuitionFee}</td>
                      <td>{program.eligibilityCriteria}</td>
                      <td>{program.totalSeats}</td>

                      <td>
                        <span
                          className={`status ${program.verifiedStatus.toLowerCase()}`}
                        >
                          {program.verifiedStatus === "approve"
                            ? "Approved"
                            : program.verifiedStatus === "reject"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </td>

                      {program.verifiedStatus === "pending" ||
                      (["approve", "reject"].includes(program.verifiedStatus) &&
                        userData?.role === "manager") ? (
                        <td>
                          <span
                            className="edit-prorgam"
                            onClick={() => {
                              navigate(`/edit-program/${program?._id}`, {
                                state: program,
                              })
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                      ) : (
                        <td>
                          <span className="edit-program">
                            <i className="fas fa-ban" />
                          </span>
                        </td>
                      )}
                      <td>
                        <span
                          onClick={() => {
                            navigate(`/view-program/${program?._id}`)
                          }}
                          className="view-program"
                        >
                          <i className="ion ion-md-eye" />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default ProgramList
